import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const SECTIONS = [
  {
    title: '第1条（サービスの概要）',
    content: 'ニジ看護転職（以下「本サービス」）は、看護師等の有資格者を対象とした転職支援サービスです。本サービスを利用するにあたり、本利用規約（以下「本規約」）に同意いただく必要があります。',
  },
  {
    title: '第2条（利用資格）',
    content: '本サービスは、看護師、准看護師、助産師、保健師の資格を有する方、または取得見込みの方を対象としています。18歳未満の方はご利用いただけません。',
  },
  {
    title: '第3条（無料サービス）',
    content: '本サービスは求職者に対して完全無料でご提供します。求人紹介、面接対策、条件交渉、入職後フォローアップを含む全サービスに費用はかかりません。',
  },
  {
    title: '第4条（個人情報の取り扱い）',
    content: 'ご登録いただいた個人情報は、転職サポートの目的にのみ使用します。詳細はプライバシーポリシーをご確認ください。',
  },
  {
    title: '第5条（禁止事項）',
    content: '本サービスのご利用にあたり、虚偽の情報登録、他者への迷惑行為、サービスの不正利用、その他法令に違反する行為を禁止します。',
  },
  {
    title: '第6条（免責事項）',
    content: '当サービスは求人情報の正確性について最善を尽くしますが、万が一情報に誤りがあった場合の損害について責任を負いかねる場合があります。',
  },
  {
    title: '第7条（規約の変更）',
    content: '本規約は予告なく変更される場合があります。変更後も本サービスを継続してご利用の場合は、変更後の規約に同意いただいたものとみなします。',
  },
  {
    title: '第8条（準拠法・管轄）',
    content: '本規約は日本法に準拠し、紛争が生じた場合は東京地方裁判所を第一審の専属管轄裁判所とします。',
  },
];

export default function TermsOfService() {
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(to bottom, #fff0f3, #fff)' }}>
      <Header />
      <main style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px 80px' }}>
        <div style={{ marginBottom: '32px' }}>
          <Link to="/" style={{ color: '#fa7c9e', fontSize: '13px', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
            <i className="ri-arrow-left-line" />
            トップへ戻る
          </Link>
        </div>

        <h1
          style={{
            fontFamily: "'Zen Maru Gothic', sans-serif",
            fontWeight: 900,
            fontSize: '28px',
            color: '#333',
            marginBottom: '8px',
          }}
        >
          利用規約
        </h1>
        <p style={{ fontSize: '13px', color: '#999', marginBottom: '32px' }}>
          最終更新日: {new Date().getFullYear()}年{new Date().getMonth() + 1}月{new Date().getDate()}日
        </p>

        <p style={{ fontSize: '14px', color: '#555', lineHeight: 1.8, marginBottom: '32px', padding: '16px 20px', background: '#fff4f4', borderRadius: '8px', borderLeft: '4px solid #fa7c9e' }}>
          ニジ看護転職（厚生労働大臣許可証：13-ユ-317878）が提供する転職支援サービスをご利用いただく前に、以下の利用規約をよくお読みください。
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {SECTIONS.map((s, i) => (
            <section key={i}>
              <h2
                style={{
                  fontWeight: 700,
                  fontSize: '16px',
                  color: '#ff5c73',
                  marginBottom: '8px',
                }}
              >
                {s.title}
              </h2>
              <p style={{ fontSize: '14px', color: '#555', lineHeight: 1.8 }}>
                {s.content}
              </p>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
